import { forwardRef, ReactNode } from 'react';

import { LoadingEllipsis } from './LoadingEllipsis';
import { LoadingMessageWrapper } from './Message.styled';
import { MESSAGE_ROLE } from './types/messages';

interface LoadingMessageProps {
  loadingMessage?: ReactNode;
}

export const LoadingMessage = forwardRef<HTMLDivElement, LoadingMessageProps>(
  (
    {
      loadingMessage = (
        <div>
          <LoadingEllipsis />
        </div>
      ),
    },
    ref,
  ) => {
    return (
      <LoadingMessageWrapper
        $type={MESSAGE_ROLE.SYSTEM}
        role="listitem"
        ref={ref}
      >
        {loadingMessage}
      </LoadingMessageWrapper>
    );
  },
);
LoadingMessage.displayName = 'LoadingMessage';
